module.exports = __webpack_public_path__ + "img/footer.45be04ce.png";